<template>
  <div>
    <PageHead title="我的整改任务"></PageHead>
    <div class="oa-layout-content">
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>

        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="add(record)">
            整改信息添加
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    scopedSlots: { customRender: "index" },
    width: 80
  },

  {
    title: "整改任务发起时间",
    dataIndex: "startTime",
    key: "startTime",
    ellipsis: true
  },
  {
    title: "发起部门",
    dataIndex: "giveOrgName",
    key: "giveOrgName",
    ellipsis: true
  },
  {
    title: "执行单位",
    dataIndex: "receiveOrgName",
    key: "receiveOrgName",
    ellipsis: true
  },

  {
    title: "任务到期时间",
    dataIndex: "endTime",
    key: "endTime",
    ellipsis: true
  },

  {
    key: "operation",
    scopedSlots: { customRender: "action" },
    title: "操作",
    align: "left",
    width: 180
  }
];
import { getTask } from "./api/api";
export default {
  data() {
    return {
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false
    };
  },
  created() {
    this.load();
  },
  methods: {
    add(record) {
      this.$router.push({
        path: "/standingBookDetails",
        query: {
          auditOrgId: record.giveOrgId,
          auditedOrgId: record.receiveOrgId,
          auditOrgName: record.giveOrgName,
          auditedOrgName: record.receiveOrgName,
          businessId: record.id
        }
      });
    },
    // 拉取列表
    load() {
      this.loading = true;
      let params = {};
      params.page = this.page;
      params.size = this.size;
      getTask(params).then(res => {
        this.loading = false;
        if (res.data.code == 0) {
          this.data = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    pageChange(pageber) {
      this.page = pageber;
      this.load();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/standingBook/myTask.vue